// Browser Notification Service

export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    console.log("This browser does not support notifications");
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  if (Notification.permission !== "denied") {
    const permission = await Notification.requestPermission();
    return permission === "granted";
  }

  return false;
};

export const showNotification = (title, options = {}) => {
  if (!("Notification" in window)) {
    return;
  }

  if (Notification.permission === "granted") {
    try {
      const notification = new Notification(title, {
        ...options,
      });

      notification.onclick = () => {
        window.focus();
        notification.close();
      };
      return notification;
    } catch (err) {
      console.error("Error creating notification:", err);
    }
  }
};

export const getNotificationPermissionStatus = () => {
  if (!("Notification" in window)) {
    return "unsupported";
  }
  return Notification.permission;
};
